import { render, staticRenderFns } from "./ImportBaseClient.vue?vue&type=template&id=5a60c9ad&"
import script from "./ImportBaseClient.vue?vue&type=script&lang=js&"
export * from "./ImportBaseClient.vue?vue&type=script&lang=js&"
import style0 from "./ImportBaseClient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports